<template>
  <div id="list-body">
    <vue-headful
      :title="`영양제웨건 - ${title.replace(/<b>/gi, '').replace(/<\/b>/gi, '')}`"
    />
    <b-row>
      <b-col sm="2" id="filter-div">
        <filter-component type='nutri' />
      </b-col>
      <b-col sm="10" id="data-div">
        <b-row>
          <b-col sm="12">
            <div class="nutri-data-wrapper" v-if="nutri">
              <h5>{{nutri_name}}</h5>
              <div class="nutri-data" v-if="nutri.recommend"><b>1일 권장량</b>: {{nutri.recommend[0]}} ~ {{nutri.recommend[1]}} {{nutri.unit}}</div>
              <div class="nutri-data" v-if="nutri.base"><b>1일 영양성분 기준치</b>: {{nutri.base}} {{nutri.unit}}</div>
              <div class="nutri-data" v-if="nutri.functions">
                <h6>효능</h6>
                <p v-for="func in nutri.functions">
                  - {{func}}
                </p>
              </div>
            </div>
            <item-table type='nutri' :loading="loading" :title="title" />
          </b-col>
        </b-row>
        <b-row align-h="center" v-show="!fullLoaded && item_count == 10">
          <b-col sm="2">
            <b-button class="button-load" variant="outline-primary" @click="loadFull">
              전체 순위 보기
              <b-icon-chevron-down v-show="!fullLoading" />
              <b-spinner small v-show="fullLoading" variant="light" label="Spinning" />
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import util from '../util'
import VueHeadful from 'vue-headful'
import ItemTable from './ItemTable'
import FilterComponent from './Filter'
import {
    BRow, BCol, BTable, BBadge, BFormGroup, BFormRadioGroup, BFormRadio, BFormCheckboxGroup, BSpinner, BCollapse, BModal,
    BIconChevronDown, BIconQuestion, BIconX, BIconFilter
} from 'bootstrap-vue'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'NutriListComponent',
  components: {
    BRow, BCol, BTable, BBadge, BFormGroup, BFormRadioGroup, BFormRadio, BFormCheckboxGroup, BSpinner, BCollapse, BModal,
    BIconChevronDown, BIconQuestion, BIconX, BIconFilter, VueHeadful, ItemTable, FilterComponent
  },
  props: {
    _nutri: { type: String, default: 'ginsenoside' }
  },
  data () {
    return {
      fullLoaded: false,
      filterOpen: false,
    }
  },
  computed: {
    ...mapState({
      loading: state => state.item.loading,
      fullLoading: state => state.item.fullLoading
    }),
    ...mapGetters('filter', {
      category: 'category',
      nutri: 'nutri'
    }),
    ...mapGetters('item', {
      item_count: 'count'
    }),
    category_name () {
      if (this.category) return this.category.name
    },
    nutri_name () {
      if (this.nutri) return this.nutri.name
    },
    isMobile () {
      return this.$store.state.isMobile
    },
    title () {
      if (this.nutri_name)
        return `100원당 <b>${this.nutri_name}</b> 함유량 순위`
      else
        return ''
    }
  },
  created () {
    this.$store.dispatch('nutri/fetchList')
  },
  methods: {
    loadFull() {
      this.$store.dispatch('item/fetchList', {type: 'nutri', full: true}).then(list => {
        this.$store.commit('item/setList', list)
        this.fullLoaded = true
      })
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler(v) {
        let params = Object.assign({}, v.params)
        let query = Object.assign({}, v.query)
        params.nutri_id = params.nutri_id || 'ginsenoside'
        this.$store.dispatch('filter/updateFromRoute', {type: 'nutri', params, query}).then(() => {
          this.$store.dispatch('item/fetchList', {full: false}).then(list => {
            this.$store.commit('item/setList', list)
          }).catch(err => {
            console.log(err)
          })
        })
      }
    }
  }
}
</script>
<style>
@media only screen and (max-width: 600px) {
  .empty-text {
    text-align: left !important;
  }
  .spinner-wrapper {
    text-align: left !important;
  }

  #data-div {
    border-left: none !important;
  }
}
.text-center {
  text-align: left !important;
}

</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.bold {
  font-weight: bold;;
}
.float-right {
  float: right;
}
.text-right {
  text-align: right;
}

.nutri-data-wrapper {
  margin-top: 20px;
}
.nutri-data {
  margin-top: 10px;
  font-size: 0.9rem;
}

.button-load {
  margin-bottom: 50px;
}

#filter-div {
  padding: 20px;
  overflow: auto;
}

#list-body {
  width: 100%;
  padding: 0 15px;
}

#data-div {
  border-left: 1px solid #d9d9d9;
  padding: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/NutriList.vue